<div class="avatar-field">
  <crm-avatar class="avatar-field__photo" [src]="displayUrl()" [name]="name()" [size]="200" fallback="icon" />

  <button
    type="button"
    class="avatar-field__edit"
    [attr.aria-haspopup]="hasImage() ? 'true' : null"
    [attr.aria-label]="'common.avatar.action.change' | translate"
    (click)="hasImage() ? menu.toggle($event) : openPicker()"
  >
    <i class="pi" [class.pi-pencil]="hasImage()" [class.pi-plus]="!hasImage()" aria-hidden="true"></i>
  </button>

  <p-menu #menu [model]="menuItems()" [popup]="true" appendTo="body" />

  <input #fileInput type="file" class="avatar-field__input" [accept]="accept" (change)="onFileSelected(fileInput)" />
</div>
